angular.module('unergie.main')
.controller('refConsentsCtrl', ($scope, BoFeaturesService, AlertManager, TableGeneratorService, DataAccess, ErrorCatcher) => {
    $scope.consentsAdmin = BoFeaturesService.isFeatureOn('consentsAdmin')
    $scope.booleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }]

    $scope.consents = {
        refreshing: false,
        show: {},
        columns: {
            id: { label: 'ID', mode: 'search_operator', mandatory: true },
            status: { label: 'Statut', mode: 'search_wildcard' },
            category: { label: 'Catégorie', mode: 'search_wildcard' },
            label: { label: 'Libellé', mode: 'search_wildcard' },
            wording_client: { label: 'Wording client', mode: 'hidden' },
            wording_vendor: { label: 'Wording vendeur', mode: 'hidden' },
            wording_mobile: { label: 'Wording mobile', mode: 'hidden' },
            step: { label: 'Étape', mode: 'search_wildcard' },
            display_order: { label: `Ordre d'affichage`, mode: 'search_operator' },
            displayed_for: { label: `Règles d'affichage`, mode: 'hidden' },
            creation_ts: { label: 'Date de création', mode: 'search_date' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.consents, 'ref-data-consents', null, null, { orderBy: 'id' })

    $scope.updateConsentFields = {
        status: { label: `Statut`, type: 'select', required: true, enum: [{ label: 'Cachée', value: 'HIDDEN' }, { label: 'Affichée', value: 'DISPLAYED' }] },
        category: { label: `Catégorie`, type: 'text', required: true },
        label: { label: `Libellé`, type: 'text', required: true },
        wording_client: { label: `Wording client`, type: 'textarea', required: true },
        wording_vendor: { label: `Wording vendeur`, type: 'textarea', required: true },
        wording_mobile: { label: `Wording mobile`, type: 'textarea', required: true },
        step: { label: `Étape`, type: 'text', required: true },
        display_order: { label: `Ordre d'affichage`, type: 'number', required: true },
        displayed_for: { label: `Règles d'affichage`, type: 'json', required: true },
    }

    $scope.updateConsentTemplate = {}

    $scope.newConsentFields = _.assign({
        id: { label: `ID consentement`, type: 'text', required: true },
    }, $scope.updateConsentFields)

    $scope.fillConsentTemplate = (consent) => {
        _.assign($scope.updateConsentTemplate, _.pick(consent, ['status', 'category', 'label', 'wording_client', 'wording_vendor', 'wording_mobile', 'step', 'display_order', 'displayed_for']))
    }

    const newConsentTemplate = {
        id: null,
        status: 'HIDDEN',
        category: null,
        label: null,
        wording_client: null,
        wording_vendor: null,
        wording_mobile: null,
        step: null,
        display_order: null,
        displayed_for: [],
    }

    $scope.newConsentTemplate = _.clone(newConsentTemplate)

    $scope.newConsent = () => {
        $scope.creating = true
        return DataAccess.createRefConsent($scope.newConsentTemplate).$promise
        .then((result) => {
            AlertManager.success(`Consentement créé`)
            $scope.refresh()
            $scope.newConsentTemplate = _.clone(newConsentTemplate)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }


    $scope.updateConsent = (consent) => {
        consent.updating = true
        return DataAccess.updateRefConsent({ id: consent.id }, $scope.updateConsentTemplate).$promise
        .then((result) => {
            AlertManager.success(`Consentement mis à jour`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            consent.updating = false
        })
    }

    $scope.toggleExpand = (consent) => {
        consent.expanded = !consent.expanded
    }

    $scope.refresh()
})
